import { useState } from 'react';
import { X, Monitor } from 'lucide-react';

const DISMISSED_KEY = 'miles-mobile-notice-dismissed';

function getDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Dismissible notice shown only on small viewports (below md).
 * Mobile is not a fully supported surface yet; this sets expectations
 * instead of letting users hit a silently degraded layout.
 */
export function MobileNotice(): JSX.Element | null {
  const [dismissed, setDismissed] = useState(getDismissed);

  if (dismissed) {
    return null;
  }

  const handleDismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, 'true');
    } catch {
      // localStorage not available
    }
    setDismissed(true);
  };

  return (
    <div className="md:hidden shrink-0 flex items-center gap-3 rounded-xl border border-white/10 bg-white/[0.06] px-4 py-3 text-sm text-white/80">
      <Monitor className="h-4 w-4 shrink-0 text-white/60" />
      <p className="flex-1 min-w-0">
        Miles works best on a desktop browser. Building and editing sites needs
        a bigger screen.
      </p>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss"
        className="p-1 rounded-md hover:bg-white/10 text-white/50 hover:text-white shrink-0"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
